import React, { useState } from "react";
import {
  Typography,
  Box,
  Button,
  IconButton,
  TextField
} from "@material-ui/core";
import { uuid } from "@/helpers/utils";
import { useTranslation } from "@/langs/useTranslation";
import ConfigSwitch from "./common/ConfigSwitch";
import { IconFile, IconTrash } from "@/components/Icon";
import { FormItem } from "@/components/Form";
import FilePicker from "@/components/FilerPicker";
import styles from "./index.module.less";
import UploadFile from "@/components/UploadFile";

const DeployFilesItem = ({ index, values, onChange, readOnly }) => {
  const { t } = useTranslation();

  const [open, setOpen] = useState(false);
  const [uploadOpen, setUploadOpen] = useState(false);
  const [checkedList, setCheckedList] = useState(null);


  const handleChange = (value, type) => {
    onChange({
      target: {
        name: `fileSynchronization.configs[${index}].${type}`,
        value
      }
    });
  };

  const handleDelete = () => {
    onChange({
      target: {
        name: "fileSynchronization.configs",
        value: values.configs.filter((_, i) => i !== index)
      }
    });
  };

  const handleAddFile = () => {
    setCheckedList(values.configs[index].files.map(file => file.id));
    setOpen(true);
  };

  const handleDeleteFile = (index, fileIndex) => {
    onChange({
      target: {
        name: `fileSynchronization.configs[${index}].files`,
        value: values.configs[index].files.filter((_, i) => i !== fileIndex)
      }
    });
  };

  const onConfirm = files => {
    setOpen(false);
    onChange({
      target: {
        name: `fileSynchronization.configs[${index}].files`,
        value: files.map(file => ({
          id: file.id,
          name: file.name,
          file_path: file.s3_path,
          md5: file.md5
        }))
      }
    });
  };

  return (
    <div
      className={styles.card}
      style={{ marginBottom: index === values.configs.length - 1 ? "" : 24 }}
    >
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        marginBottom={1.5}
      >
        <Typography variant="h6">
          {t({ defaultMessage: "文件同步配置" })} {index + 1}
        </Typography>
        <IconButton onClick={handleDelete}>
          <IconTrash size={16} color="#ff0000" />
        </IconButton>
      </Box>
      <FormItem
        label={t({ defaultMessage: "设备文件夹名称" })}
        colon
        row
        labelBold
      >
        <TextField
          variant="outlined"
          size="small"
          fullWidth
          readOnly={readOnly}
          placeholder={t({ defaultMessage: "输入文件夹路径" })}
          value={values.configs[index].folder_path}
          onChange={e => handleChange(e.target.value, "folder_path")}
        />
      </FormItem>
      <Button
        color="primary"
        variant="outlined"
        size="large"
        style={{ marginBottom: 16 }}
        onClick={handleAddFile}
      >
        {t({ defaultMessage: "添加" })}
      </Button>
      <Button
        color="primary"
        variant="outlined"
        size="large"
        style={{ marginBottom: 16, marginLeft: 16 }}
        onClick={() => setUploadOpen(true)}
      >
        {t({ defaultMessage: "本地上传" })}
      </Button>
      {values.configs[index]?.files.length > 0 && (
        <div
          className={styles.card}
          style={{ paddingTop: 12, paddingBottom: 12, backgroundColor: "#fff" }}
        >
          {values.configs[index].files.map((file, i) => (
            <Box
              key={file.id}
              display="flex"
              justifyContent="space-between"
              alignItems="center"
            >
              <Box display="flex" alignItems="center">
                <IconFile
                  size="1.2rem"
                  color="primary"
                  style={{ marginRight: 6 }}
                />
                <Typography variant="subtitle2" component="span">
                  {file.name}
                </Typography>
              </Box>
              <IconButton onClick={() => handleDeleteFile(index, i)}>
                <IconTrash size={12} color="#ff0000" />
              </IconButton>
            </Box>
          ))}
        </div>
      )}
      <FilePicker
        title={t({ defaultMessage: "选择文件" })}
        open={open}
        onClose={() => setOpen(false)}
        fileType=""
        checkedList={checkedList}
        onConfirm={onConfirm}
      />
      <UploadFile 
        open={uploadOpen}
        onClose={() => setUploadOpen(false)}
        onSuccess={data => {
          onChange({
            target: {
              name: `fileSynchronization.configs[${index}].files`,
              value: [...values.configs[index].files,
              {
                id: data.id,
                name: data.name,
                file_path: data.file_path,
                md5: data.md5
              }
            ]
            }
          });
        }}
      />
    </div>
  );
};

const DeployFiles = ({ values, onChange, readOnly }) => {
  const { t } = useTranslation();

  const handleAddConfig = () => {
    onChange({
      target: {
        name: "fileSynchronization.configs",
        value: [
          ...values.configs,
          {
            folder_path: "",
            files: [],
            id: uuid()
          }
        ]
      }
    });
  };

  return (
    <Box flex={1}>
      <Typography variant="h5" style={{ marginBottom: 32 }}>
        {t({ defaultMessage: "文件同步" })}
      </Typography>
      <ConfigSwitch
        title={t({ defaultMessage: "是否启用" })}
        name="fileSynchronization.open"
        readOnly={readOnly}
        onChange={onChange}
        marginBottom={3}
        value={values.open}
      />
      {values.open && (
        <>
          <Button
            color="primary"
            variant="outlined"
            size="large"
            style={{ marginBottom: 24 }}
            onClick={handleAddConfig}
          >
            {t({ defaultMessage: "添加配置" })}
          </Button>

          {values.configs.map((config, index) => (
            <DeployFilesItem
              name="fileSynchronization.configs"
              key={config.id}
              index={index}
              values={values}
              onChange={onChange}
              readOnly={readOnly}
            />
          ))}
        </>
      )}
    </Box>
  );
};

export const initValues = {
  open: false,
  configs: []
};

export default DeployFiles;
